module.exports = __webpack_public_path__ + "assets/img/small-loader.afd1e7fa.svg";